import { render, staticRenderFns } from "./MessageHandler.vue?vue&type=template&id=3309b376&scoped=true&"
import script from "./MessageHandler.vue?vue&type=script&lang=js&"
export * from "./MessageHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309b376",
  null
  
)

export default component.exports